import React from 'react';
import { Route, Switch } from 'react-router-dom';

// PAGES
import RegimeList from './RegimeList';
import RegimeNew from './RegimeNew';
import RegimeView from './RegimeView';

function Regime(props) {
    const { match } = props;

    return (
        <Switch>
            <Route path={match.path} exact component={RegimeList} />
            {/*<Route path={`${match.path}/new`} exact component={RegimeNew} />*/}
            <Route path={`${match.path}/:cod`} component={RegimeView} />
            
        </Switch>
    )
}

export default Regime;
